/**
 *  groupBy
 *
 *  @fileOverview A function for grouping elements in an array. Same idea as lodash groupBy.
 *  @pulledFrom https://stackoverflow.com/questions/14446511/most-efficient-method-to-groupby-on-an-array-of-objects
 *  @example
 *  console.log(groupBy(['one', 'two', 'three'], 'length'));
 *  returns: {3: ["one", "two"], 5: ["three"]}
 */
export const groupBy = (items, key) => items.reduce(
  (result, item) => ({
    ...result,
    [item[key]]: [
      ...(result[item[key]] || []),
      item
    ]
  }),
  {},
);
